<ng-select #ngSelect [disabled]="disabled" [tabindex]="disabled ? -1 : 0" [ngClass]="{
           'menu-select-ng-select': true,
           'attached':isAttachedSelect,
           'panel-top': dropDownPosition === 'top',
           'panel-wide-width': !!dropDownWideWidth,
           'limited-height': limitedHeight,
           'left': dropDownSide === 'left',
           'disabled': disabled,
           'open': !disabled && isOpen,
           'error': hasError}" [style]="{
           '--width':width}" [(ngModel)]="_tempSelected" [items]="filteredItems$()" [clearable]="false"
  [searchable]="false" [multiple]="isMultiSelect" [closeOnSelect]="!isMultiSelect" [compareWith]="effectiveCompareWith"
  [selectOnTab]="true" [clearOnBackspace]="false" [groupBy]="groupFn" [selectableGroup]="false" [virtualScroll]="virtualScroll"
  [appendTo]="effectiveAppendTo" [dropdownPosition]="dropDownPosition" [fixedPlaceholder]="true" [hideSelected]="hideSelected" (close)="close()"
  (open)="onOpen()" (change)="singleSelect()" bindLabel="label">

  <ng-template ng-placeholder-tmp>
    <ng-container *ngTemplateOutlet="_currentTemplate"></ng-container>
  </ng-template>

  <ng-template ng-header-tmp *ngIf="searchable || selectAllAndClearOptions || customHeaderTemplate">
    <div class="drop-down-header">
      <ng-container *ngIf="customHeaderTemplate">
        <ng-container *ngTemplateOutlet="customHeaderTemplate"></ng-container>
      </ng-container>
      <ng-content *ngIf="searchable">
        <div class="search-container">
          <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="filterItems($event)"
            placeholder="{{searchPlaceholder}}" class="search-input" />
          <img [src]="'svg/search-gray.svg' | assetVersion" [style.color]="'black'" alt="icon"
            (error)="onImageError($event)">

        </div>
      </ng-content>
      <ng-content *ngIf="selectAllAndClearOptions">
        <div class="select-header-buttons">
          <button type="button" (click)="selectAll()">
            Select All
          </button>
          <button type="button" (click)="clearAll()">
            Clear
          </button>
        </div>
      </ng-content>
    </div>
  </ng-template>


  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
    <div class="select-item-option" [attr.data-testid]="'select-option-' + item.key" [attr.title]="item.tooltip || null" [class.disabled]="!!item$.disabled" (click)="handleItemClick(item, item$)">
      <ng-content *ngIf="isMultiSelect">
        <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" />
      </ng-content>
      <ng-content *ngIf="item.icon">
        <img [ngStyle]="iconStyle" [class]="'icon'" [src]="item.icon | assetVersion" alt="icon"
          (error)="onImageError($event)">
      </ng-content>
      <span *ngIf="!item.hint">{{ item.label }}</span>
      <div *ngIf="item.hint" class="select-item-text">
        <span>{{ item.label }}</span>
        <span class="select-item-hint">{{ item.hint }}</span>
      </div>
    </div>
  </ng-template>

  <ng-template ng-optgroup-tmp *ngIf="isMultiSelect" let-item="item">
    <div class="select-menu-group">
      {{ item.label }}
    </div>
  </ng-template>

  <ng-template ng-footer-tmp *ngIf="isMultiSelect">
    <ng-content class="select-footer">
      <div class="select-footer">
        <span *ngIf="exceedsMaxSelected" class="select-footer-error">Select up to {{ maxSelectedItems }} items</span>
        <button type="button" class="select-footer-button cancel" (click)="close()">Cancel</button>
        <button type="button" [ngClass]="{
                                      'select-footer-button': true,
                                      'apply':true
                         }" [class.disabled]="disableApply" (click)="close(true)">
          Apply</button>
      </div>
    </ng-content>
  </ng-template>
</ng-select>


<ng-template #selectContainer let-text="text" let-showIcon="showIcon" let-iconPath="iconPath"
  let-iconStyle="iconStyle" let-containerClass="containerClass" let-textClass="textClass">
  <div [ngClass]="containerClass">
    <img *ngIf="showIcon && iconPath" class="container-icon" [src]="iconPath | assetVersion"
      [ngStyle]="iconStyle" alt="icon" (error)="onImageError($event)">
    <span [class]="textClass">{{ text }}</span>
    <img class="arrow" [src]="arrowIcon | assetVersion" alt="'icon'">
  </div>
</ng-template>


<ng-template #multiLabel>
  <ng-container *ngIf="showAllSelectedIcons; else defaultMultiLabel">
    <div class="multi-value-container" [class.disabled]="disabled">
      <ng-container *ngFor="let item of previewsValue.slice(0, maxIconsAmount)">
        <img *ngIf="item.icon" class="icon-chip" [ngClass]="iconShape" [src]="item.icon | assetVersion" alt="icon"
          (error)="onImageError($event)">
      </ng-container>
      <div class="icon-chip" *ngIf="previewsValue.length > maxIconsAmount">+{{ previewsValue.length - maxIconsAmount }}
      </div>
      <img class="arrow" [src]="arrowIcon | assetVersion" alt="'icon'">
    </div>
  </ng-container>
  <ng-template #defaultMultiLabel>
    <ng-container *ngTemplateOutlet="selectContainer;context:this.getTemplateContext(TemplateType.MULTI_LABEL)">
    </ng-container>
  </ng-template>
</ng-template>
<ng-template #placeholderTmp>
  <ng-container *ngTemplateOutlet="selectContainer;context:this.getTemplateContext(TemplateType.PLACEHOLDER)">
  </ng-container>
</ng-template>
<ng-template #singleLabel>
  <ng-container
    *ngTemplateOutlet="selectContainer;context:this.getTemplateContext(TemplateType.SINGLE_LABEL, selected)">
  </ng-container>
</ng-template>
